import React from "react";

const EducationalQualificationsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M11 18L4 14.2V8.2L0 6L11 0L22 6V14H20V7.1L18 8.2V14.2L11 18ZM11 9.7L17.85 6L11 2.3L4.15 6L11 9.7ZM11 15.725L16 13.025V9.25L11 12L6 9.25V13.025L11 15.725Z"
      fill="#FFBA08"
    />
  </svg>
);

const ExperienceRequirementsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M4 14H6V9H4V14ZM12 14H14V4H12V14ZM8 14H10V11H8V14ZM8 9H10V7H8V9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16ZM2 2V16V2Z"
      fill="#FFBA08"
    />
  </svg>
);

interface EligibilityCard {
  icon: React.ElementType;
  title: string;
  points: string[];
}

const eligibilityCards: EligibilityCard[] = [
  {
    icon: EducationalQualificationsIcon,
    title: "Educational Qualifications:",
    points: [
      "A bachelor’s degree from an accredited institution",
      "Final-year graduation students can also begin the course",
    ],
  },
  {
    icon: ExperienceRequirementsIcon,
    title: "Experience Requirements:",
    points: [
      "A minimum of 2 years of relevant experience in management accounting or financial management completed before starting, or within 7 years of passing the exam",
    ],
  },
];

const CmaCourseEligibility = () => {
  return (
    <section
      className="w-full bg-black bg-no-repeat bg-cover md:bg-center md:py-[50px]
        md:bg-[url('https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-course/CPA_Course_Eligibility_desk.webp')]
        max-md:bg-top max-md:py-6
        max-md:bg-[url('https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-course/CPA_Course_Eligibility_mob.webp')]"
    >
      <div className="main_container">
        {/* Section Heading */}
        <h2 className="md:text-[32px] text-[24px] font-bold text-left md:text-center leading-[1.2]">
          <span className="text-[#FFBA08]">CMA</span>
          <span className="text-white"> Eligibility Criteria</span>
        </h2>

        <p className="text-white md:text-sm text-sm font-semibold leading-[1.5] text-left md:text-center md:mt-6 mt-6">
          CMA admission requirements are refreshingly simple:
        </p>

        {/* Eligibility cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-5 gap-4 max-w-[840px] mx-auto md:mt-8 mt-8">
          {eligibilityCards?.map((card) => {
            const Icon = card.icon;
            return (
              <div
                key={card.title}
                className="rounded-[8px] border border-[#173350] bg-[rgba(0,43,91,0.20)] md:p-4 p-3"
              >
                <div className="flex items-start md:gap-2 gap-1.5">
                  <span className="shrink-0 w-[22px] flex items-center mt-[2px]">
                    <Icon />
                  </span>
                  <div className="min-w-0">
                    <h3 className="text-[#FFBA08] md:text-sm text-[13px] font-bold leading-[20px]">
                      {card.title}
                    </h3>
                    <ul
                      className={`text-white md:text-sm text-[14px] font-medium leading-[20px] mt-1 list-disc pl-4 ${
                        card.points.length === 1
                          ? "md:list-none md:pl-0"
                          : "md:pl-5"
                      }`}
                    >
                      {card.points?.map((point) => (
                        <li key={point}>{point}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CmaCourseEligibility;
